export const RESERVE_COMMON_NOTE_LIMITS = Object.freeze({
  maxItems: 20,
  maxCharacters: 200,
  maxLines: 3,
})

let graphemeSegmenter = null

function getGraphemeSegmenter() {
  if (graphemeSegmenter) return graphemeSegmenter
  if (typeof Intl === 'undefined' || typeof Intl.Segmenter !== 'function') return null

  graphemeSegmenter = new Intl.Segmenter(undefined, {granularity: 'grapheme'})
  return graphemeSegmenter
}

export function normalizeCommonNoteLineEndings(value) {
  return String(value == null ? '' : value).replace(/\r\n?/g, '\n')
}

export function normalizeCommonNoteContent(value) {
  return normalizeCommonNoteLineEndings(value).trim()
}

export function countCommonNoteCharacters(value) {
  const content = normalizeCommonNoteLineEndings(value)
  const segmenter = getGraphemeSegmenter()

  return segmenter
    ? Array.from(segmenter.segment(content)).length
    : Array.from(content).length
}

export function countCommonNoteLines(value) {
  const content = normalizeCommonNoteLineEndings(value)
  return content ? content.split('\n').length : 0
}

export function createCommonNoteDraft(items = []) {
  const draft = items.slice(0, RESERVE_COMMON_NOTE_LIMITS.maxItems).map(item => ({
    id: item.id == null ? null : item.id,
    content: normalizeCommonNoteLineEndings(item.content),
  }))

  while (draft.length < RESERVE_COMMON_NOTE_LIMITS.maxItems) {
    draft.push({id: null, content: ''})
  }

  return draft
}

export function validateCommonNoteDraft(items) {
  const normalizedRows = items.map((item, index) => ({
    id: item.id == null ? null : item.id,
    content: normalizeCommonNoteContent(item.content),
    row: index + 1,
  }))
  const errors = normalizedRows.map(() => [])
  const duplicateRows = new Map()

  normalizedRows.forEach((item, index) => {
    if (!item.content) return

    if (countCommonNoteCharacters(item.content) > RESERVE_COMMON_NOTE_LIMITS.maxCharacters) {
      errors[index].push({code: 'MAX_CHARACTERS'})
    }
    if (countCommonNoteLines(item.content) > RESERVE_COMMON_NOTE_LIMITS.maxLines) {
      errors[index].push({code: 'MAX_LINES'})
    }

    const rows = duplicateRows.get(item.content) || []
    rows.push(item.row)
    duplicateRows.set(item.content, rows)
  })

  duplicateRows.forEach(rows => {
    if (rows.length < 2) return
    rows.forEach(row => {
      errors[row - 1].push({code: 'DUPLICATE_CONTENT', rows})
    })
  })

  return {
    errors,
    items: normalizedRows
      .map(({id, content}) => ({...(content && id != null ? {id} : {}), content})),
    valid: errors.every(rowErrors => rowErrors.length === 0),
  }
}

export function appendCommonNote(currentValue, selectedValue) {
  const current = currentValue == null ? '' : String(currentValue)
  const selected = selectedValue == null ? '' : String(selectedValue)

  if (!current) return selected
  if (!selected) return current
  return current.endsWith('\n') ? `${current}${selected}` : `${current}\n${selected}`
}
